import { render, staticRenderFns } from "./CatalogModal.vue?vue&type=template&id=77454bee&scoped=true&"
import script from "./CatalogModal.vue?vue&type=script&lang=ts&"
export * from "./CatalogModal.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogModal.vue?vue&type=style&index=0&id=77454bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77454bee",
  null
  
)

export default component.exports